(() => {
  const ROOT = '#drawer-cross-sell';
  const FLAG_KEY = '_cross_sell';
  const FLAG_VAL = 'drawer_upsell';

  // ===== Preorder toggle (robust) =====
  // 優先順位:
  // 1) #drawer-cross-sell の data-preorder-badge="off|on"
  // 2) window.XS_PREORDER_BADGE = "off|on"
  // 3) window.CROSS_SELL_CONFIG (or script#xs-config / data-config) の aliases.CONFIG.tags に cfg:preorder_badge:off
  // 4) なければデフォルトON
  const CFG_ALIAS_KEY = 'CONFIG';
  const CFG_PREORDER_OFF = 'cfg:preorder_badge:off';

  const q  = (sel, ctx=document) => ctx.querySelector(sel);
  const qa = (sel, ctx=document) => Array.from(ctx.querySelectorAll(sel));

  function normalizeTags(tags){
    if (Array.isArray(tags)) return tags.map(t => String(t).trim()).filter(Boolean);
    if (typeof tags === 'string') return tags.split(',').map(t => t.trim()).filter(Boolean);
    return [];
  }

  const getCrossSellConfig = () => {
    const w = window;

    // 1) windowに積んでる場合（推奨）
    const fromWindow = w.CROSS_SELL_CONFIG || w.__CROSS_SELL_CONFIG__ || w.XS_CROSS_SELL_CONFIG;
    if (fromWindow && typeof fromWindow === 'object') return fromWindow;

    // 2) <script type="application/json" id="xs-config"> に埋めてる場合
    const el = document.getElementById('xs-config') || document.getElementById('cross-sell-config');
    if (el && el.textContent) {
      try { return JSON.parse(el.textContent); } catch {}
    }

    // 3) drawer-cross-sell要素の data-config に直書きしてる場合
    const wrap = q(ROOT);
    if (wrap?.dataset?.config) {
      try { return JSON.parse(wrap.dataset.config); } catch {}
    }

    return null;
  };

  const resolvePreorderSwitch = () => {
    // 1) data属性
    const wrap = q(ROOT);
    const dataVal = (wrap?.dataset?.preorderBadge || '').toLowerCase();
    if (dataVal === 'off') return false;
    if (dataVal === 'on') return true;

    // 2) window変数
    const wVal = String(window.XS_PREORDER_BADGE || '').toLowerCase();
    if (wVal === 'off') return false;
    if (wVal === 'on') return true;

    // 3) JSON CONFIGタグ
    const json = getCrossSellConfig();
    if (json) {
      const cfgTags = normalizeTags(json?.aliases?.[CFG_ALIAS_KEY]?.tags);
      if (cfgTags.includes(CFG_PREORDER_OFF)) return false;
    }

    // 4) default ON
    return true;
  };

  const applyPreorderVisibility = () => {
    const wrap = q(ROOT);
    if (!wrap) return;

    const show = resolvePreorderSwitch();
    // 予約カードはこれ（あなたが貼ってくれたHTML）
    qa('.xs-card.is-preorder', wrap).forEach(card => {
      card.style.display = show ? '' : 'none';
    });
  };

  const fetchCart = () =>
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials:'same-origin', cache:'no-store' })
      .then(r => r.json());

  const refreshDrawer = async () => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    await syncSelectedState();
    syncNoneCards();
    applyPreorderVisibility();
  };

  const getFlagged = async () => {
    const cart = await fetchCart();
    return cart.items.filter(it => String(it.properties?.[FLAG_KEY]) === FLAG_VAL);
  };

  const addVariantOnce = async (variantId) => {
    const flagged = await getFlagged();
    if (flagged.some(it => String(it.variant_id) === String(variantId))) return true;
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({
        id: String(variantId),
        quantity: 1,
        properties: { [FLAG_KEY]: FLAG_VAL }
      })
    });
    return res.ok;
  };

  const removeVariantIfFlagged = async (variantId) => {
    const cart = await fetchCart();
    const targets = cart.items.filter(it =>
      String(it.properties?.[FLAG_KEY]) === FLAG_VAL &&
      String(it.variant_id) === String(variantId)
    );
    for (const t of targets) {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: t.key, quantity: 0 })
      });
    }
  };

  const fetchVariantIdByHandle = async (handle) => {
    try {
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`, {
        credentials:'same-origin', cache:'no-store'
      });
      if (!r.ok) return '';
      const p = await r.json();
      const v = (p.variants||[]).find(v => v.available) || (p.variants||[])[0];
      return v ? String(v.id) : '';
    } catch { return ''; }
  };

  const removeGroupFlagged = async (groupRoot) => {
    const checked = qa('.xs-card__check:checked', groupRoot);
    if (!checked.length) return;
    const cart = await fetchCart();
    for (const input of checked) {
      let variantId = input.dataset.varId || '';
      if (!variantId || input.value === '__fetch__') {
        const handle = input.getAttribute('data-handle');
        variantId = await fetchVariantIdByHandle(handle);
        if (!variantId) continue;
      }
      const targets = cart.items.filter(it =>
        String(it.properties?.[FLAG_KEY]) === FLAG_VAL &&
        String(it.variant_id) === String(variantId)
      );
      for (const t of targets) {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: t.key, quantity: 0 })
        });
      }
    }
  };

  const syncSelectedState = async () => {
    const wrap = q(ROOT);
    if (!wrap) return;
    qa('.xs-card', wrap).forEach(el => el.classList.remove('is-selected'));
    qa('.xs-card__check', wrap).forEach(inp => (inp.checked = false));

    const flagged = await getFlagged();
    const flaggedIds = new Set(flagged.map(it => String(it.variant_id)));
    qa('.xs-card__check', wrap).forEach(inp => {
      const vid = inp.dataset.varId;
      if (vid && flaggedIds.has(String(vid))) {
        inp.checked = true;
        inp.closest('.xs-card')?.classList.add('is-selected');
      }
    });
  };

  const syncNoneCards = () => {
    const wrap = q(ROOT);
    if (!wrap) return;
    qa('.xs-group', wrap).forEach(gr => {
      const none = gr.querySelector('.xs-card__none');
      if (!none) return;
      const any = gr.querySelectorAll('.xs-card__check:checked').length > 0;
      none.checked = !any;
      none.closest('.xs-card')?.classList.toggle('is-selected', !any);
    });
  };

  const onChangeCheck = async (ev) => {
    const input = ev.target?.closest?.('.xs-card__check');
    if (!input) return;

    input.closest('.xs-card')?.classList.toggle('is-selected', input.checked);
    syncNoneCards();

    const val = String(input.value);
    let variantId = input.dataset.varId;

    if (input.checked) {
      if (!variantId || val === '__fetch__') {
        const handle = input.getAttribute('data-handle');
        variantId = await fetchVariantIdByHandle(handle);
        if (!variantId) { await refreshDrawer(); return; }
        input.dataset.varId = variantId;
      }
      const ok = await addVariantOnce(variantId);
      await refreshDrawer();
      if (!ok) {
        const none = q(`.xs-group[data-group="${input.getAttribute('data-group')}"] .xs-card__none`, q(ROOT));
        if (none) none.checked = true;
        syncNoneCards();
      }
    } else {
      if (!variantId || val === '__fetch__') {
        const handle = input.getAttribute('data-handle');
        variantId = await fetchVariantIdByHandle(handle);
        if (!variantId) { await refreshDrawer(); return; }
      }
      await removeVariantIfFlagged(variantId);
      await refreshDrawer();
    }
  };

  const onChangeNone = async (ev) => {
    const none = ev.target?.closest?.('.xs-card__none');
    if (!none) return;
    const group = none.getAttribute('data-group');
    const wrap = q(ROOT);
    const groupRoot = wrap?.querySelector(`.xs-group[data-group="${group}"]`);
    if (!groupRoot) return;

    await removeGroupFlagged(groupRoot);
    await refreshDrawer();
  };

  const bind = () => {
    const wrap = q(ROOT);
    if (!wrap || wrap.dataset.bound) return;

    wrap.addEventListener('change', (e) => {
      if (e.target.closest('.xs-card__check')) return onChangeCheck(e);
      if (e.target.closest('.xs-card__none'))  return onChangeNone(e);
    });

    wrap.dataset.bound = 'true';
    syncSelectedState().then(() => {
      syncNoneCards();
      applyPreorderVisibility();
    });
  };

  const boot = () => {
    bind();
    applyPreorderVisibility();

    const obsTarget = document.getElementById('sidebar-cart') || document.documentElement;
    const mo = new MutationObserver(() => {
      bind();
      applyPreorderVisibility();
    });
    mo.observe(obsTarget, { childList:true, subtree:true });
    document.addEventListener('cart:open',    () => { bind(); applyPreorderVisibility(); });
    document.addEventListener('cart:updated', () => { bind(); applyPreorderVisibility(); });
    document.addEventListener('cart:refresh', () => { bind(); applyPreorderVisibility(); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
